import React from 'react';
import styles from './Preloader.module.scss';

const Preloader = () => <div className={styles.preloader} />;

export default Preloader;
